import MyVillaPageContent from '../components/myvilla/MyvillaPageContent';

const MyVillaPage = () => {
  return <MyVillaPageContent />;
};

export default MyVillaPage;